module.exports = __webpack_public_path__ + "static/media/icon_pen.481b58ec.svg";